import React, {useState, useEffect, useRef} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
 

const DailytaxobligationEdit = ()=>{
     const [taxDate, setTaxDate ] = useState('');
     const [depositTotal, setDepositTotal ] = useState('');
     const [withdrawalTotal, setWithdrawalTotal ] = useState('');
     const [taxOnDeposit, setTaxOnDeposit ] = useState('');
     const [taxOnWithdrawal, setTaxOnWithdrawal ] = useState('');
     const [totalTaxAmount, setTotalTaxAmount ] = useState('');
     const [trxCode, setTrxCode ] = useState('');
     const [prnCode, setPrnCode ] = useState('');
    const [redirect, setRedirect] = useState(false);
    const ref = useRef<HTMLInputElement>(null);

    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`dailytaxobligation/${id}`);
                 setTaxDate(data.tax_date);
                 setDepositTotal(data.deposit_total);
                 setWithdrawalTotal(data.withdrawal_total);
                 setTaxOnDeposit(data.tax_on_deposit);
                 setTaxOnWithdrawal(data.tax_on_withdrawal);
                 setTotalTaxAmount(data.total_tax_amount);
                 setTrxCode(data.trx_code);
                 setPrnCode(data.prn_code);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`dailytaxobligation/${id}`, {
            taxDate,
            depositTotal,
            withdrawalTotal,
            taxOnDeposit,
            taxOnWithdrawal,
            totalTaxAmount,
            trxCode,
            prnCode,
        });
        console.log(data);
        setRedirect(true);
    };
    
    if(redirect){
         return <Navigate to={'/dailytaxobligation'} />
    }
    return (
        <Wrapper pageTitle={'Edit Dailytaxobligation'}>
            <InnerNav createLink={'/dailytaxobligationCreate'} listLink={'/dailytaxobligation'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TaxDate </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TaxDate" value={taxDate}
                        onChange = {e => setTaxDate(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">DepositTotal </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="DepositTotal" value={depositTotal}
                        onChange = {e => setDepositTotal(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">WithdrawalTotal </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="WithdrawalTotal" value={withdrawalTotal}
                        onChange = {e => setWithdrawalTotal(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TaxOnDeposit </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TaxOnDeposit" value={taxOnDeposit}
                        onChange = {e => setTaxOnDeposit(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TaxOnWithdrawal </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TaxOnWithdrawal" value={taxOnWithdrawal}
                        onChange = {e => setTaxOnWithdrawal(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TotalTaxAmount </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TotalTaxAmount" value={totalTaxAmount}
                        onChange = {e => setTotalTaxAmount(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TrxCode </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TrxCode" value={trxCode}
                        onChange = {e => setTrxCode(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">PrnCode </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="PrnCode" value={prnCode}
                        onChange = {e => setPrnCode(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default DailytaxobligationEdit;